import { CompanyTypeEnum, CompanyDetailTab, CompanyStatusEnum } from '@core/models';
import { TabViewModel } from '@core/models/tab-view.model';

export const MY_COMPANY_USERS_PAGE_SIZE = 25;

export const MY_COMPANY_TABS: Array<TabViewModel> = [
  { index: CompanyDetailTab.General, title: 'companies.detailTabs.general.label', route: 'general' },
  { index: CompanyDetailTab.Users, title: 'companies.detailTabs.users.label', route: 'users' },
];

export const COMPANY_TYPES = [
  {
    index: CompanyTypeEnum.Customer,
    label: 'companies.filter.partnerType',
  },
  {
    index: CompanyTypeEnum.Installer,
    label: 'companies.filter.installerType',
  },
  {
    index: CompanyTypeEnum.SubInstaller,
    label: 'companies.filter.subInstallerType',
  },
];

export const COMPANY_STATUS = [
  {
    index: CompanyStatusEnum.Active,
    label: 'companies.filter.active',
  },
  {
    index: CompanyStatusEnum.Inactive,
    label: 'companies.filter.inactive',
  },
  {
    index: CompanyStatusEnum.PendingVerification,
    label: 'companies.filter.pendingVerification',
  },
];

export const COUNTRIES = [
  {
    id: 'NL',
    label: 'The Netherlands',
  },
  {
    id: 'BE',
    label: 'Belgium',
  },
  {
    id: 'DE',
    label: 'Germany',
  },
];
